/**
 * The hearing party's phone leg of a call this interpreter took by transfer
 * (vrs-server/lib/voice-leg-handover.js), as their match stored it
 * (vrs_active_call.phoneLeg). The web and native rooms join it on entry
 * (twilioVoiceService.joinTransferredPhoneLeg) instead of dialling: the
 * hearing party is already on the line.
 */
import { getPersistentJson } from '../vrs-auth/storage';
function text(value) {
    return typeof value === 'string' ? value.trim() : '';
}
/** The stored leg, if it belongs to this room's call; otherwise null. */
export function storedTransferredPhoneLeg(roomName, callId) {
    const stored = getPersistentJson('vrs_active_call');
    const storedCallId = text(stored?.callId);
    const callSid = text(stored?.phoneLeg?.callSid);
    const conferenceName = text(stored?.phoneLeg?.conferenceName);
    if (!storedCallId || !callSid || !conferenceName || (callId && storedCallId !== callId)
        || (roomName && text(stored?.roomName) && text(stored?.roomName) !== roomName)) {
        return null;
    }
    return {
        callSid,
        conferenceName,
        platformCallId: storedCallId,
        sessionId: text(stored?.phoneLeg?.sessionId) || text(stored?.roomName) || roomName || ''
    };
}
